module.exports = __webpack_public_path__ + "img/timeline_miscevent-6.09c8cef3.jpg";